// import React, { useEffect, useState } from 'react'
// import { useTranslation } from 'react-i18next';
// import { useLocation, useParams } from 'react-router-dom'
// import NavbarDesktopDropdown from './NavbarDesktopDropdown';

// export default function NavbarDesktopFutureMineralsMenu() {
//     const { t } = useTranslation();
//     const { lng } = useParams();
//     const location = useLocation();
//     const [isFutureMineralsOpen, setIsFutureMineralsOpen] = useState(false);

//     const handleToggleFutureMinerals = () => {
//         setIsFutureMineralsOpen(!isFutureMineralsOpen);
//     };

//     useEffect(() => {
//         setIsFutureMineralsOpen(false);
//     }, [location.pathname]);


//     return (
//         <>
//             {isFutureMineralsOpen && <div onClick={handleToggleFutureMinerals} className="absolute z-10 top-0 left-0 bottom-0 min-h-screen w-full" />}
//             <li className="relative z-[100]" >
//                 <div className="cursor-pointer select-none whitespace-nowrap py-1.5 px-3" onClick={handleToggleFutureMinerals}>
//                     {t("FUTURE_MINERALS")}
//                 </div>
//                 {isFutureMineralsOpen && <NavbarDesktopDropdown lng={lng} />}
//             </li>
//         </>

//     );
// }











import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom'
import NavbarDesktopDropdown from './NavbarDesktopDropdown';

export default function NavbarDesktopFutureMineralsMenu() {
    const { t } = useTranslation();
    const { lng } = useParams();
    const location = useLocation();
    const [isFutureMineralsOpen, setIsFutureMineralsOpen] = useState(false);

    // Fonctions pour gérer le survol
    const handleMouseEnter = () => setIsFutureMineralsOpen(true);
    const handleMouseLeave = () => setIsFutureMineralsOpen(false);

    useEffect(() => {
        setIsFutureMineralsOpen(false);
    }, [location.pathname]);

    return (
        // Le survol est géré sur tout le <li> (libellé + flèche) pour que la flèche
        // ouvre le menu elle aussi.
        <li
            className="relative z-[100]"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div className="flex cursor-pointer select-none items-center gap-1.5 whitespace-nowrap py-1.5 px-3">
                {t("FUTURE_MINERALS")}
                <span
                    className={`inline-block text-[10px] transition-transform duration-300 ease-in-out ${
                        isFutureMineralsOpen ? 'rotate-180' : ''
                    }`}
                >
                    ▼
                </span>
            </div>
            {isFutureMineralsOpen && <NavbarDesktopDropdown lng={lng} />}
        </li>
    );
}






